import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client/core/index.js';
import { SetContextLink } from '@apollo/client/link/context/index.js';
import { ErrorLink } from '@apollo/client/link/error/index.js';

function getCookieValue(cookieHeader: string | null, key: string): string | null {
  if (cookieHeader === null || cookieHeader === '') {
    return null;
  }
  const cookies = cookieHeader.split(';').map((c) => c.trim());
  const tokenCookie = cookies.find((c) => c.startsWith(`${key}=`));
  return tokenCookie !== undefined ? (tokenCookie.split('=')[1] ?? null) : null;
}

const httpLink = new HttpLink({
  uri: '/graphql',
  credentials: 'include',
});

const authLink = new SetContextLink((_prevContext) => {
  const token = getCookieValue(document.cookie, 'merritrac-admin-token');
  const existingHeaders = (_prevContext['headers'] ?? {}) as Record<string, string>;
  return {
    headers: {
      ...existingHeaders,
      ...(token !== null ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
});

const logoutLink = new ErrorLink(({ error }) => {
  if ('statusCode' in error && (error as { statusCode: number }).statusCode === 401) {
    document.cookie = 'merritrac-admin-token=; Max-Age=0; path=/';
    window.location.href = '/login';
  }
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(logoutLink).concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          serviceOrders: {
            keyArgs: ['status', 'clientCode', 'assignedTo'],
          },
          users: {
            keyArgs: false,
          },
          clients: {
            keyArgs: false,
          },
        },
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    },
  },
});
